// Code generated by master-scheme ServiceTypesGenerator - DO NOT EDIT
// Generator: /Users/victorvins/Projects/master-scheme/dsl/src/ts-api/ServiceTypesGenerator.scala

import { postEndpoint } from '@innolab-trader/tradovate-transport'
import type { ValidationError } from '@innolab-trader/tradovate-types'
import type { SecondMarketDataSubscription } from '@innolab-trader/tradovate-types'
import type { SubscriptionErrorCode } from '@innolab-trader/tradovate-types/src/enums/subscriptionErrorCode'

export interface CancelSecondMarketDataSubscription {
  secondMarketDataSubscriptionId: number
}

export interface SecondMarketDataSubscriptionResponse {
  errorText?: string
  errorCode?: SubscriptionErrorCode
  secondMarketDataSubscription?: SecondMarketDataSubscription
}

/**
 * Validate CancelSecondMarketDataSubscription request
 *
 * Follows Rust validation pattern with structured errors
 *
 * @param request - The request object to validate
 * @returns Array of validation errors, empty if valid
 *
 * @example
 * ```typescript
 * const errors = validateCancelSecondMarketDataSubscription(requestData)
 * if (errors.length > 0) {
 *   return { status: 400, errors }
 * }
 * ```
 */
export function validateCancelSecondMarketDataSubscription(request: CancelSecondMarketDataSubscription): ValidationError[] {
  const errors: ValidationError[] = []

  const req = request as unknown as Record<string, unknown>
  if (req.secondMarketDataSubscriptionId === undefined || req.secondMarketDataSubscriptionId === null) {
    errors.push({
      field: 'secondMarketDataSubscriptionId',
      code: 'required',
      message: 'secondMarketDataSubscriptionId is required'
    })
  }

  return errors
}

export const cancelSecondMarketDataSubscription = postEndpoint<CancelSecondMarketDataSubscription, SecondMarketDataSubscriptionResponse>('/user/cancelSecondMarketDataSubscription')
